


export const DirectoryInformation_START = 'DirectoryInformation_START';
export const DirectoryInformation_END = 'DirectoryInformation_END';
export const DirectoryInformation_ERROR = 'DirectoryInformation_ERROR';
export const DirectoryInformation_SUCCESS = 'DirectoryInformation_SUCCESS';
export const DirectoryInformation_FAIL = 'DirectoryInformation_FAIL';

export const IsDataSubmitedSuccessfullyDirectoryInformation = 'IsDataSubmitedSuccessfullyDirectoryInformation'